import { inject } from 'mobx-react'
import React from 'react'
import { Query } from 'react-apollo'
import Loader from '../../common/loader/Loader'
import { fetchStation } from './stationQueries'
import type { Station, StationStore } from './stationTypes'

type ReminderType = {
  id: string
  time: string
  name: string
  weekdays: string[]
}

type DecoratorProps = {
  stationStore: StationStore
}

const withActiveStation = (WrappedComponent: any): any => {
  @inject('stationStore')
  class Decorator extends React.PureComponent<DecoratorProps> {
    render() {
      const { stationStore } = this.props
      if (!stationStore.activeStationId) {
        return <WrappedComponent {...this.props} />
      }

      return (
        <Query<
          {
            station: Station
          },
          {
            id: string
          }
        >
          query={fetchStation}
          variables={{
            id: stationStore.activeStationId,
          }}
          fetchPolicy={'network-only'}
        >
          {({ data, error, loading }) => (
            <Loader
              {...{
                error,
                loading,
              }}
              hideSpinner
            >
              <WrappedComponent activeStation={data && data.station ? data.station : null} {...this.props} />
            </Loader>
          )}
        </Query>
      )
    }
  }

  return Decorator
}

export type WithActiveStationProps = {
  activeStation: Station
}
export default withActiveStation
